var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgPassportVisa = function SvgPassportVisa(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8E1538",
    d: "M55.003 32c.55 0 .997.448.997 1s-.446 1-.997 1H37.997A.998.998 0 0 1 37 33c0-.552.446-1 .997-1zM20.5 14c4.692 0 8.5 3.808 8.5 8.5S25.192 31 20.5 31a8.498 8.498 0 0 1-8.5-8.5c0-4.692 3.808-8.5 8.5-8.5zm0 2a6.503 6.503 0 0 0-6.5 6.5c0 3.59 2.907 6.5 6.5 6.5 3.588 0 6.5-2.912 6.5-6.5S24.088 16 20.5 16zm30.486 7c.56 0 1.014.448 1.014 1s-.454 1-1.014 1H38.014c-.56 0-1.014-.448-1.014-1s.454-1 1.014-1zM8 47a1 1 0 0 1-1-1c0-7.726 6.032-14 13.5-14S34 38.274 34 46a1 1 0 0 1-1 1H8zm23.96-2c-.486-6.169-5.437-11-11.46-11-6.023 0-10.974 4.831-11.46 11h22.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B3A3A",
    fillRule: "nonzero",
    d: "M58.876 6H5.131C2.298 6 0 8.317 0 11.164v41.664C0 55.682 2.297 58 5.131 58H58.87C61.707 58 64 55.686 64 52.836V11.164C64.01 8.32 61.711 6 58.876 6zm0 2c1.726 0 3.13 1.417 3.124 3.16v41.676C62 54.586 60.598 56 58.869 56H5.13C3.406 56 2 54.581 2 52.828V11.164C2 9.418 3.407 8 5.131 8h53.745z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPassportVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/passport-visa.5516eb9f.svg";
export { ForwardRef as ReactComponent };